import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  reviewCount: number;
}
const TrustpageReviewCount = ({ reviewCount }: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="caption">
        {reviewCount} {t('nav_reviews')}
      </Typography>
    </Box>
  );
};

export default TrustpageReviewCount;
